import React from 'react'
import Scrollspy from 'react-scrollspy'
import PropTypes from 'prop-types'
import { createSlug } from '../core/urls'

const FAQSpy = props => {
  const { faqs, isVisible } = props
  const sections = faqs.map(faq => createSlug(faq.QuestionText))

  const handleClick = (hash, e) => {
    document.getElementById(hash).scrollIntoView({
      behavior: 'smooth',
    })
    e.preventDefault()
  }

  return (
    faqs.length <= 12 && (
      <div className="hidden xxxl:flex inset-y-0 right-0 absolute max-w-xs z-20">
        <div
          className={`opacity-0 transition-opacity transition-250 ml-auto ${
            !isVisible ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <nav
            role="navigation"
            className="text-secondary sticky top-0 pt-32 pr-8 pb-32"
          >
            <h2 className="uppercase text-xs text-body-light font-semibold mb-3 pl-4">
              On this page
            </h2>
            <Scrollspy
              items={sections}
              offset={-200}
              currentClassName="border-secondary"
            >
              {(faqs || []).map(faq => {
                let faqSlug = createSlug(faq.QuestionText)
                return (
                  <li
                    key={faq.QuestionText}
                    className="py-2 px-4 text-md border-l-2 border-body-lightest"
                  >
                    <a
                      href={`#${faqSlug}`}
                      className="fill-current hover:text-primary"
                      onClick={e => handleClick(faqSlug, e)}
                    >
                      {faq.QuestionText}
                    </a>
                  </li>
                )
              })}
            </Scrollspy>
          </nav>
        </div>
      </div>
    )
  )
}

FAQSpy.propTypes = {
  FAQs: PropTypes.array,
  isVisible: PropTypes.bool,
}

export default FAQSpy
